import axios from "axios";
import router from "@/router/router";
// 配置新建一个 axios 实例
const Axios = axios.create({
  timeout: 50000,
  baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URL : '/api',
  // baseURL:'https://plus.escroud.com',
  //https://plus.escroud.com
    Accept: '*/*',
  headers: {
    // "content-type": "application/json",
    // authorization:'YWRtaW4gdGVzdC1hcHBrZXktMTIz',
    token:'',
  },
  // responseType: "blob",

  transformResponse: (data) => {
    try {
      return data;
    } catch (err) {
      return data;
    }
  },
});

// 添加请求拦截器
Axios.interceptors.request.use(
  (config) => {
    const url = new URL(config.url, process.env.NODE_ENV === 'production' ? config.baseURL : window.location.origin);
    config.headers.token = `${localStorage.getItem('token')}`;
    config.url = url.pathname + url.search + url.hash;
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
Axios.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    // 检查响应头的 Content-Type
    const contentType = response.headers['content-type'];

    // 如果是文件下载（二进制数据），直接返回响应
    if (contentType && contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
      return response;
    }
    if (response.data){
        const res = JSON.parse(response.data) ;
        if (res.code!== 200) {
          if (res.code== 401){
            router.push('/login')
          }
          // `token` 过期或者账号已在别处登录
          return res;
        } else {
          return JSON.parse(response.data);
          // return response.data
        }

    }

  },
  (error) => {
    if (error.response.code== 401){
      router.push('/login')
    }
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);
//
// 导出 axios 实例

export { Axios };
